import NBType, { InferType } from '@netbase/nb-type'
import GeoType from '../enums/GeoType'

const GeoDisplaySchema = NBType.object().shape('GeoDisplaySchema', {
  /* @prop */
  displayName: NBType.string(),
  /* @prop */
  geoId: NBType.string(),
  /* @prop */
  geoType: NBType.enum(GeoType),
  /* @prop */
  info: NBType.string()
  /* END */
})
export default GeoDisplaySchema
export type GeoDisplay = InferType<typeof GeoDisplaySchema>
// RESERVE BELOW
